import { render, staticRenderFns } from "./SettingsOverview.vue?vue&type=template&id=239e0f97"
import script from "./SettingsOverview.vue?vue&type=script&lang=js"
export * from "./SettingsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports